"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAvatar = UserAvatar;
var _Avatar2 = _interopRequireDefault(require("@mui/material/Avatar"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireDefault(require("react"));
var _icons = require("../icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const colors = ['#2AC682', '#BB8A1A', '#528BE8', '#F36565', '#FA823E', '#DD428D', '#CF58E1', '#743AEF', '#1589BB', '#268B1D', '#846858'];
function UserAvatar({
  size: _size,
  bgColor,
  color,
  user
}) {
  const size = _size || 32;
  if (user === undefined) return /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    sx: {
      flexShrink: 0,
      height: size,
      width: size
    },
    variant: "circular"
  });
  if (user === null) return /*#__PURE__*/_react.default.createElement(_Avatar2.default, {
    sx: ({
      palette
    }) => ({
      bgcolor: bgColor || palette.primary.light,
      color,
      fontSize: size && typeof size === 'number' && size >= 48 ? '1.5rem' : undefined,
      fontWeight: size && typeof size === 'number' && size >= 48 ? 700 : undefined,
      height: size,
      width: size
    })
  }, /*#__PURE__*/_react.default.createElement(_icons.PersonIcon, {
    fontSize: "small",
    sx: {
      color: '#fff'
    }
  }));
  const {
    profilePicture,
    username
  } = user;
  let firstLetter = username && String.fromCodePoint(username.codePointAt(0) || 0);
  if (firstLetter?.match(/[a-z]/i)) firstLetter = firstLetter?.toUpperCase();
  return profilePicture ? /*#__PURE__*/_react.default.createElement(_Avatar2.default, {
    src: profilePicture,
    sx: {
      height: size,
      width: size
    }
  }) : /*#__PURE__*/_react.default.createElement(_Avatar2.default, {
    sx: ({
      palette
    }) => ({
      bgcolor: bgColor || (firstLetter ? (0, _styles.lighten)(colors[firstLetter.charCodeAt(0) % colors.length], 0.8) : palette.primary.light),
      color: color || (firstLetter ? colors[firstLetter.charCodeAt(0) % colors.length] : undefined),
      fontSize: size && typeof size === 'number' && size >= 48 ? '1.5rem' : undefined,
      fontWeight: size && typeof size === 'number' && size >= 48 ? 700 : undefined,
      height: size,
      width: size
    })
  }, firstLetter || /*#__PURE__*/_react.default.createElement(_icons.PersonIcon, {
    fontSize: "small",
    sx: {
      color: '#fff'
    }
  }));
}